// DOM-centric Utility Functions

export const getScrollbarWidth = () => {
    const inner = document.createElement('p')
    const outer = document.createElement('div')

    inner.style.width = '100%'
    inner.style.height = '200px'

    outer.className = 'scrollbar-width-test'
    outer.style.position = 'absolute'
    outer.style.top = '-150px'
    outer.style.left = '-200px'
    outer.style.width = '200px'
    outer.style.height = '150px'
    outer.style.visibility = 'hidden'
    outer.style.overflow = 'scroll'

    outer.appendChild(inner)
    document.body.appendChild(outer)

    const width = outer.offsetWidth - inner.clientWidth
    document.body.removeChild(outer)

    return width
}
